import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Divider, List, ListItem } from '@mui/material';
import img2024 from './../resources/pastAwardsListImages/awards2024.png';
import img2023 from './../resources/pastAwardsListImages/awards2023.png';
import img2022 from './../resources/pastAwardsListImages/awards2022.png';
import img2025 from './../resources/pastAwardsListImages/awards2025.png';
import { Box } from '@mui/system';

function PastAwardsAccordian() {

    return(
        
    <div>
      <Accordion sx={{border: 3, borderColor: 'primary.main'}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="h5" sx={{color: 'primary.blackC'}}>
            <b> Past Awards </b></Typography>

        </AccordionSummary>
        <AccordionDetails>
            <Divider></Divider>
          <Typography variant="h6" sx={{color: 'primary.blackC'}}>
            
            <p>Every year on PMA Foundation day, PMA awards the distinguished organisaitons and/or Individuals for their exceptional contributions. 
                Here is the list of past Awards conferred by PMA.
              </p>

              <Box component="img" 
                    src={img2025} 
                    alt={"Awards 2025"} 
                    sx={{ height: "250px", maxWidth: "1074px" }}/>
                
                <Divider sx={{m:2}}/>

               <Box component="img" 
                    src={img2024} 
                    alt={"Awards 2024"} 
                    sx={{ height: "250px", maxWidth: "1074px" }}/>
                
                <Divider sx={{m:2}}/>

                  <Box component="img" 
                    src={img2023} 
                    alt={"Awards 2023"} 
                    sx={{ height: "250px", maxWidth: "1074px" }}/>
                
                <Divider sx={{m:2}}/>

                  <Box component="img" 
                    src={img2022} 
                    alt={"Awards 2022"} 
                    sx={{ height: "250px", maxWidth: "1074px" }}/>
                
                
                
                

          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  
    );
}
export default PastAwardsAccordian;